import { Component, Host, Prop, h } from '@stencil/core';
import { getAvatarSize } from '@utils/imageUtils';

import { SizeVariant } from 'src/types';

@Component({
  tag: 'sportsline-expert-avatar',
  styleUrl: 'sportsline-expert-avatar.css',
  shadow: true,
})
export class SportslineExpertAvatar {
  /**
   * The avatar props, the avatarUrl is the image URL, altText is the alt text for the image, and size is the size of the avatar.
   */
  @Prop() alt: string;
  /**
   * The avatar props, the avatarUrl is the image URL, altText is the alt text for the image, and size is the size of the avatar.
   */
  @Prop() src: string;
  /**
   * The avatar props, the avatarUrl is the image URL, altText is the alt text for the image, and size is the size of the avatar.
   */
  @Prop() size: SizeVariant;

  render() {
    return (
      <Host>
        <img
          class={{
            'sportsline-expert-avatar': true,
            'sportsline-expert-avatar--small': this.size === 'small',
            'sportsline-expert-avatar--medium': this.size === 'medium',
            'sportsline-expert-avatar--large': this.size === 'large',
            'sportsline-expert-avatar--extra-large': this.size === 'extra-large',
          }}
          src={this.src}
          width={getAvatarSize(this.size)}
          alt={this.alt}
          loading="lazy"
        />
      </Host>
    );
  }
}
